export const PdfSource = {
  Vehicle: 'vehicle',
  Quicko: 'quicko',
} as const;

export type PdfSourceType = (typeof PdfSource)[keyof typeof PdfSource];
